import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authAPI } from '../services/api';

function FindAccountPage() {
  const [searchParams] = useSearchParams();
  const [tab, setTab] = useState(searchParams.get('tab') === 'password' ? 'password' : 'id');

  // 아이디 찾기
  const [nickname, setNickname] = useState('');
  const [accounts, setAccounts] = useState(null);

  // 비밀번호 찾기
  const [email, setEmail] = useState('');
  const [sentMessage, setSentMessage] = useState('');
  const [devResetUrl, setDevResetUrl] = useState('');

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const switchTab = (next) => {
    setTab(next);
    setError('');
    setAccounts(null);
    setSentMessage('');
    setDevResetUrl('');
  };

  const handleFindId = async (e) => {
    e.preventDefault();
    setError('');
    setAccounts(null);
    setLoading(true);

    try {
      const res = await authAPI.findId(nickname);
      setAccounts(res.data.accounts);
    } catch (err) {
      setError(err.response?.data?.error || '아이디 찾기에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError('');
    setSentMessage('');
    setDevResetUrl('');
    setLoading(true);

    try {
      const res = await authAPI.forgotPassword(email);
      setSentMessage(res.data.message);
      if (res.data.devResetUrl) setDevResetUrl(res.data.devResetUrl);
    } catch (err) {
      setError(err.response?.data?.error || '요청에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const tabStyle = (active) => ({
    flex: 1,
    padding: '10px 0',
    background: 'none',
    border: 'none',
    borderBottom: active ? '2px solid #6C5CE7' : '2px solid #2A2A3E',
    color: active ? '#E4E4E4' : '#8B8B9E',
    fontWeight: active ? 'bold' : 'normal',
    cursor: 'pointer',
    fontSize: '0.95rem',
  });

  return (
    <div className="auth-container">
      <div className="auth-card card">
        <h1>keunson</h1>
        <p>계정 정보를 찾아드립니다</p>

        <div style={{ display: 'flex', marginBottom: 20 }}>
          <button type="button" style={tabStyle(tab === 'id')} onClick={() => switchTab('id')}>
            아이디 찾기
          </button>
          <button type="button" style={tabStyle(tab === 'password')} onClick={() => switchTab('password')}>
            비밀번호 찾기
          </button>
        </div>

        {error && <div className="error-msg">{error}</div>}

        {tab === 'id' && (
          <>
            <form onSubmit={handleFindId}>
              <div className="form-group">
                <label>닉네임 (방송 활동명)</label>
                <input
                  type="text"
                  className="form-input"
                  value={nickname}
                  onChange={(e) => setNickname(e.target.value)}
                  placeholder="가입 시 입력한 닉네임"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
                {loading ? '조회 중...' : '아이디 찾기'}
              </button>
            </form>

            {accounts !== null && (
              <div style={{ marginTop: 16 }}>
                {accounts.length === 0 ? (
                  <p style={{ color: '#8B8B9E', textAlign: 'center' }}>일치하는 계정이 없습니다.</p>
                ) : (
                  accounts.map((acc, i) => (
                    <div
                      key={i}
                      style={{
                        padding: '12px 16px',
                        background: '#16213E',
                        borderRadius: 8,
                        marginBottom: 8,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <span style={{ fontWeight: 'bold' }}>{acc.email}</span>
                      <span style={{ color: '#8B8B9E', fontSize: '0.8rem' }}>
                        {new Date(acc.createdAt).toLocaleDateString('ko-KR')} 가입
                      </span>
                    </div>
                  ))
                )}
              </div>
            )}
          </>
        )}

        {tab === 'password' && (
          <>
            {sentMessage ? (
              <div style={{ textAlign: 'center', padding: '12px 0' }}>
                <p style={{ color: '#00D2D3', lineHeight: 1.6 }}>{sentMessage}</p>
                {devResetUrl && (
                  <p style={{ marginTop: 12, fontSize: '0.8rem', wordBreak: 'break-all' }}>
                    <span style={{ color: '#8B8B9E' }}>개발모드 링크: </span>
                    <a href={devResetUrl}>{devResetUrl}</a>
                  </p>
                )}
              </div>
            ) : (
              <form onSubmit={handleForgotPassword}>
                <div className="form-group">
                  <label>가입한 이메일</label>
                  <input
                    type="email"
                    className="form-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="email@example.com"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
                  {loading ? '발송 중...' : '재설정 링크 받기'}
                </button>
              </form>
            )}
          </>
        )}

        <p style={{ textAlign: 'center', marginTop: 16, color: '#8B8B9E' }}>
          <Link to="/login">로그인으로 돌아가기</Link>
        </p>
      </div>
    </div>
  );
}

export default FindAccountPage;
